import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

function normalizeRole(role) {
  if (role === 'oper' || role === 'admin') return role;
  return 'user';
}

function roleMatches(allowedRoles, role) {
  return allowedRoles.includes(normalizeRole(role));
}

/**
 * Renders children only when logged in and role is allowed.
 * @param {string[]} allowedRoles - e.g. ['admin'], ['oper','admin'], ['user']
 */
export default function RoleRoute({ children, allowedRoles, redirectTo = '/' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const loggedIn = useSelector((s) => s.auth.loggedIn);
  const user = useSelector((s) => s.user);

  useEffect(() => {
    if (user.loading) return;

    if (!loggedIn) {
      toast.info('Please log in to continue.');
      navigate(redirectTo, { replace: true, state: { from: location.pathname } });
      return;
    }

    if (!roleMatches(allowedRoles, user.role)) {
      toast.error('You do not have access to this page.');
      navigate(redirectTo, { replace: true });
    }
    // Pass stable `allowedRoles` (e.g. module-level frozen arrays) to avoid effect churn.
  }, [loggedIn, user.loading, user.role, allowedRoles, navigate, redirectTo, location.pathname]);

  if (user.loading) {
    return null;
  }
  if (!loggedIn || !roleMatches(allowedRoles, user.role)) {
    return null;
  }
  return children;
}
